import { render, staticRenderFns } from "./OfficeTab.vue?vue&type=template&id=dc2976a0&scoped=true&"
import script from "./OfficeTab.vue?vue&type=script&lang=js&"
export * from "./OfficeTab.vue?vue&type=script&lang=js&"
import style0 from "./OfficeTab.vue?vue&type=style&index=0&id=dc2976a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc2976a0",
  null
  
)

export default component.exports